import { ActivatedRouteSnapshot, Data } from '@angular/router';
import { BreadcrumbItem } from '@scalefast/core';

export class BreadcrumbHelper {
  /**
   * Remove breadcrumb that doesn't make sense without the parameter that follows it
   */
  public static removeOrphanedBreadcrumb(breadcrumbs: BreadcrumbItem[]): BreadcrumbItem[] {
    const index = breadcrumbs.findIndex((item) => item.path.includes(':')) - 1;
    if (index > -1) {
      breadcrumbs.splice(index, 1);
    }

    return breadcrumbs;
  }

  /**
   * Remove the colons from the breadcrumb label and path if are present
   */
  public static removeColonsFromBreadcrumb(breadcrumbs: BreadcrumbItem[]): BreadcrumbItem[] {
    breadcrumbs = breadcrumbs.map((item) => {
      return {
        label: item.label.replace(/:/g, ''),
        path: item.path.replace(/:/g, ''),
      };
    });

    return breadcrumbs;
  }

  /**
   * Remove the hyphens from the breadcrumb label and path if are present
   */
  public static removeHyphensFromBreadcrumb(breadcrumbs: BreadcrumbItem[]): BreadcrumbItem[] {
    breadcrumbs = breadcrumbs.map((item) => {
      return {
        label: item.label.replace(/-/g, ' '),
        path: item.path,
      };
    });

    return breadcrumbs;
  }

  /**
   * Get the label from the route data
   * @param data Data
   * @returns string
   */
  public static getLabel(data: Data): string {
    return typeof data.breadcrumb === 'function' ? data.breadcrumb(data) : data.breadcrumb;
  }

  /**
   * Get the URL from the route and replace the parameters with the actual values
   * @param route ActivatedRouteSnapshot
   * @param path string
   * @returns string
   */
  public static getUrl(route: ActivatedRouteSnapshot, path?: string): string | undefined {
    let url = route.routeConfig?.path;

    if (route.params) {
      Object.keys(route.params).forEach((key) => {
        if (this.routeParamsIncludesLocale(route.params[key])) {
          url = url?.replace(`:${key}/`, '');
        } else {
          url = url?.replace(`${key}`, route.params[key]);
        }
      });
    }

    return path ? `${path}/${url}` : url;
  }

  /**
   * Identifies if a section of the route params could be a locale, to remove it from the breadcrumb
   */
  public static routeParamsIncludesLocale(routeParam: string): boolean {
    let includesLocale = false;
    // This regex should identify all strings that looks like a locale, with a format similar to 'es-es'
    const localeRegex = new RegExp('^[a-z]{2}-[a-z]{2}$');
    // @TODO: Check this to identify better if the breacrumb section belongs to a locale one
    if (routeParam.match(localeRegex)) {
      includesLocale = true;
    }
    return includesLocale;
  }

  public static getNameFromRoute(breadcrumb: any): string {
    return breadcrumb.page.name ? breadcrumb.page.name : breadcrumb.page.breadcrumb;
  }
}
